function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29,27.38V12.98c0-1.6-.96-3.07-2.49-3.83l-8.32-4.08c-1.37-.67-3.01-.67-4.38,0L5.49,9.15c-1.53,.75-2.49,2.22-2.49,3.83v14.4",
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1,17h13.8c1.16,0,2.1,.94,2.1,2.1v5.9H7v-5.9c0-1.16,.94-2.1,2.1-2.1Z",
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,17v-.39c0-1.2-.44-2.35-1.24-3.25h0c-.49-.55-1.18-.86-1.91-.86h-5.7c-.73,0-1.43,.31-1.91,.86h0c-.8,.89-1.24,2.05-1.24,3.25v.39",
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 21,
    r: 1,
    style: {
      fill: "#69757c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 1,
    style: {
      fill: "#69757c"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 24,
    x2: 19,
    y2: 24,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 23,
    x2: 18,
    y2: 23,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 26,
    x2: 10,
    y2: 26,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 27,
    x2: 10,
    y2: 27,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 26,
    x2: 25,
    y2: 26,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 27,
    x2: 25,
    y2: 27,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 21,
    x2: 7,
    y2: 27,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 21,
    x2: 25,
    y2: 27,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,25s0-2,2-2h6s2,0,2,2H11Z",
    style: {
      fill: "#69757c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.332eabd4e2442b947fab9460f7e4eb8b.svg";
export { ForwardRef as ReactComponent };